export default function UserAvatar({ name, photo, className = 'h-11 w-11' }: { name: string; photo?: string | null; className?: string }) {
  return <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-[#b63279] to-[#38296f] font-bold text-white ${className}`}>
    {photo ? <img src={photo} alt={`Foto de ${name}`} className="h-full w-full object-cover" /> : <span aria-hidden="true">{name.trim().split(/\s+/).slice(0, 2).map(p => p[0]).join('').toUpperCase()}</span>}
  </span>;
}
